import React from "react"
import BaseSubheadline from "../common/BaseSubheadline"
import { SecondaryHeadingTextTilesType } from "../../types/mainModulTypes"
import BaseRichtext from "../common/BaseRichtext"
import { API } from "../../constants/constants"
import { HashLink } from "react-router-hash-link"

export default function SecondaryHeadingTextTiles(props: SecondaryHeadingTextTilesType) {
    const blockLength = props.secondaryHeadingTextTilesBlock.length

    return (
        <div className="max-w-content mx-auto px-4 md:px-0">
            <div className="text-center max-w-content-sm mx-auto pb-12">
                <BaseSubheadline label={props.secondaryHeadingTextTilesHeading} classProps="pb-4" />
                <BaseRichtext content={props.secondaryHeadingTextTilesText} />
            </div>
            <div
                className={`${
                    blockLength === 4 ? "grid grid-cols-2 max-w-lg mx-auto" : " flex flex-wrap-reverse items-center justify-center"
                } gap-8`}>
                {props.secondaryHeadingTextTilesBlock?.map((tile, index) => {
                    return (
                        <HashLink
                            to={tile.secondaryHeadingTextTilesLink}
                            key={index}
                            className="w-48 md:w-64 rounded-default bg-accent aspect-square flex flex-col items-center justify-end px-2 pt-4 pb-4 md:pb-8 border-4 gap-4"
                            style={{ borderColor: tile.secondaryHeadingTextTilesColor, color: tile.secondaryHeadingTextTilesColor }}>
                            <img
                                src={API + tile.secondaryHeadingTextTilesIcon?.url}
                                alt={tile.secondaryHeadingTextTilesIcon?.description || tile.secondaryHeadingTextTilesIcon?.name}
                                className="w-24 md:w-32 max-h-24 md:max-h-32 object-contain"
                            />

                            <BaseRichtext
                                content={tile.secondaryHeadingTextTilesTitle}
                                classProps={`text-center break-all !text-base font-semibold`}
                            />
                        </HashLink>
                    )
                })}
            </div>
        </div>
    )
}
